export default __webpack_public_path__ + "static/media/warning.44fd0b0e.svg";